import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'

import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { OrderPipe } from 'ngx-order-pipe'
import * as JSZip from 'jszip'

import { Documento } from 'src/app/models/documento.model'
import { RegistroAtividade } from 'src/app/models/registroAtividade.model'
import { TipoAtividade } from 'src/app/models/tipoAtividade.model'
import { Usuario } from 'src/app/models/usuario.model'
import { Email } from 'src/app/models/email.model'
import { Grupo } from 'src/app/models/grupo.model'

import { LoginService } from 'src/app/shared/login.service'
import { EmailService } from 'src/app/shared/email.service'
import { NotificationService } from 'src/app/shared/notification.service'
import { MessageService } from 'src/app/shared/message.service'
import { ProfileService } from 'src/app/shared/profile.service'

import { GrupoService } from '../grupos/grupos.service'
import { UploadInternoService } from './upload-interno.service'

import { environment } from 'src/environments/environment'

const ambiente = environment.descricaoAmbiente
const messageSendEmailCalculoRetroativo = environment.messageSendEmailCalculoRetroativo
const urlPTA = environment.msalConfig.redirectUri

@Component({
	selector: 'app-upload-interno',
	templateUrl: './upload-interno.component.html',
	styleUrls: ['./upload-interno.component.scss'],
})
export class UploadInternoComponent implements OnInit, OnDestroy {
	@ViewChild('fileInput', { static: false }) fileInput: ElementRef
	dynamicUrl = '/upload/interno'
	arquivos: Array<RegistroAtividade> = []
	usuarioNome: string = ''
	usuarios: Array<Usuario> = []
	codigo: string
	registroAtividade: RegistroAtividade
	documento: Documento
	processo: string = ''
	responseEnvioArquivo: any

	infoMessage = { status: 0, message: '' }

	file: any
	fileUpload = { status: 'initial', message: 0, filePath: '' }
	profileForm: FormGroup
	modalRef: NgbModalRef
	isDisabled: boolean = true
	sucessRequest: boolean = false
	nameInputFile: string = ''
	error: string
	zipFile: JSZip

	//envio email
	emailGrupo: string = ''
	destinatarios: any
	anoMes: string = ''

	// search
	_listFilter: string
	filtered: Array<RegistroAtividade> = []
	filter = new FormControl('')

	// paginação
	page = 1
	pageSize = 50
	collectionSize: number
	pagefiltered: Array<RegistroAtividade> = []
	order: string = 'DataCriacao'

	loginDisplay: boolean = false
	perfilCalculoRetroativo: boolean = false
	perfilTecnico: boolean = false

	private subscriptions: Subscription[] = []

	constructor(
		private uploadInternoService: UploadInternoService,
		private emailService: EmailService,
		private loginService: LoginService,
		private grupoService: GrupoService,
		private formBuilder: FormBuilder,
		private orderPipe: OrderPipe,
		private notificationService: NotificationService,
		public messageService: MessageService,
		private profileService: ProfileService
	) {
		//this.emailGrupo = this.perfilCalculoRetroativo ? 'calculoretroativo' : ''
		this.processo = 'calculoretroativo_valia'

		this.orderPipe.transform(this.arquivos, this.order)
		this.orderPipe.transform(this.pagefiltered, this.order)
		this.createProfileForm()
	}

	ngOnInit(): void {
		console.log('=== ngOnInit ===')
		this.profileService.verificarPerfis()
		this.perfilCalculoRetroativo = this.profileService.getPerfilCalculoRetroativo()
		this.perfilTecnico = this.profileService.getPerfilTecnico()
		this.loginDisplay = this.perfilCalculoRetroativo || this.perfilTecnico
		console.log('perfilCalculoRetroativo:', this.perfilCalculoRetroativo)
		console.log('perfilTecnico:', this.perfilTecnico)
		console.log('loginDisplay:', this.loginDisplay)

		this.subscriptions.push(
			this.loginService.user$.subscribe((user) => {
				this.usuarioNome = user?.name || ''
				console.log('usuarioNome:', this.usuarioNome)
			})
		)

		if (this.loginDisplay) {
			console.log('Carregando registros...')
			this.getRegistros()
		} else {
			console.log('Sem permissão de acesso')
			this.infoMessage = { status: 1, message: 'Usuário não tem permissão para acessar esta página.' }
		}

		this.messageService.clear()
	}

	adicionaZero(numero) {
		if (numero <= 9) return '0' + numero
		else return numero
	}

	get listFilter(): string {
		return this._listFilter
	}

	set listFilter(value: string) {
		this._listFilter = value
		this.filtered = this.listFilter ? this.onFilter(this.listFilter) : this.arquivos
		this.collectionSize = this.filtered.length
		this.refreshPage()
	}

	onFilter(text: string): Array<RegistroAtividade> {
		return this.arquivos.filter((arquivo) => {
			var date = this.formatedDate(arquivo.dataHora)
			const term = text.toLowerCase()
			return (
				arquivo.nomeArquivoEnviado!.toLowerCase().includes(term) ||
				// @ts-ignore: Object is possibly 'null'.
				date.includes(term)
			)
		})
	}

	refreshPage() {
		this.pagefiltered = this.filtered
			.map((record, i) => ({ index: i + 1, ...record }))
			.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize)
	}

	cleanFiltered() {
		this.listFilter = ''
		this.refreshPage()
	}

	getRegistros() {
		this.infoMessage.status = 2
		this.uploadInternoService.getRegistros(this.processo).subscribe((res) => {
			if (res.status >= 400) {
				this.notificationService.showMessage(res.status, res.statusText, 'read', this.dynamicUrl)
			} else {
				if (res._count == 0) {
					this.infoMessage = { status: 1, message: 'Não exitem arquivos enviandos para este processo!' }
				} else {
					this.infoMessage.status = 3
					this.arquivos = res.Documents
					this.filtered = this.arquivos
					this.collectionSize = this.arquivos.length
					this.refreshPage()
				}
			}
		})
	}

	nameFileFormated(file: any) {
		var slip = file.name.split('.')
		var splitName = slip[0].split('_')
		var splitExt = slip[1]
		var qt = splitName.length
		console.log(qt, 'qt')

		if (qt < 3) {
			return file
		}

		this.codigo = splitName[0]
		this.anoMes = splitName[qt - 1]
		var extensao = splitExt

		var processos = splitName.slice(1, qt - 1)

		file['nome'] = `${this.codigo}_${processos.join('_')}_${this.anoMes}.${extensao}`
		file['tipo'] = `${extensao}`
		this.file = file
	}

	onSelectedFile(event) {
		console.log('=== onSelectedFile ===')
    this.messageService.clear()
		this.nameFileFormated(event.target.files[0])
		this.nameInputFile = this.file.nome
		console.log('nameInputFile:', this.nameInputFile)
		console.log('codigo extraído:', this.codigo)
		console.log('anoMes extraído:', this.anoMes)

		if (this.nameInputFile.includes('calculoretroativo_valia')) {
			console.log('Arquivo válido para calculoretroativo_valia')
			this.onFilesCalculoRetroativo()
		} else {
			console.log('Arquivo NÃO válido para calculoretroativo_valia')
			this.notificationService.showMessage(403, 'Este usuário não tem permissão para enviar este tipo de arquivo!', 'info', this.dynamicUrl)
			this.resetForm()
		}
	}

	onFilesCalculoRetroativo() {
		if (this.file.size === 0) {
			this.notificationService.showMessage(404, 'O arquivo está sem conteúdo.', 'create', this.dynamicUrl)
			this.isDisabled = true
		} else {
			switch (this.file.tipo) {
				case 'txt':
					let files: any
					this.uploadCheckedCaracteres(this.file).then((res) => {
						files = res
						if (files!.name.match(/\d{1,4}\_.+\_(?![a-zA-Z])(\d{1,6})\.txt/)) {
							this.isDisabled = false
							this.profileForm.get('profile')?.setValue(files)
						} else {
							this.notificationService.showMessage(
								400,
								`O arquivo - ${this.file.nome} está com sua descrição fora do padrão esperado codigo_processo_anoMes`,
								'create',
								this.dynamicUrl
							)
							this.resetForm()
						}
					})
					break
				case 'xlsx':
					if (this.file.nome.match(/\d{1,4}\_.+\_(?![a-zA-Z])(\d{1,6})\.xlsx/)) {
						this.isDisabled = false
						this.profileForm.get('profile')?.setValue(this.file)
					} else {
						this.notificationService.showMessage(
							400,
							`O arquivo - ${this.file.nome}, está com sua descrição fora do padrão esperado codigo_processo_anoMes`,
							'create',
							this.dynamicUrl
						)
						this.resetForm()
					}
					break
				case 'xls':
					if (this.file.nome.match(/\d{1,4}\_.+\_(?![a-zA-Z])(\d{1,6})\.xls/)) {
						this.isDisabled = false
						this.profileForm.get('profile')?.setValue(this.file)
					} else {
						this.notificationService.showMessage(
							400,
							`O arquivo - ${this.file.nome}, está com sua descrição fora do padrão esperado codigo_processo_anoMes`,
							'create',
							this.dynamicUrl
						)
						this.resetForm()
					}
					break
				default:
					this.isDisabled = true
					break
			}
		}
	}

	clearInputFile() {
		this.fileInput.nativeElement.value = ''
	}

	resetForm() {
		this.isDisabled = true
		this.nameInputFile = ''
		this.profileForm.reset()
		this.clearInputFile()
	}

	createProfileForm() {
		this.profileForm = this.formBuilder.group({
			name: ['', [Validators.required]],
			profile: ['', [Validators.required]],
		})
	}

	onCreate() {
		console.log('=== onCreate ===')
		this.sucessRequest = false
		const formData = new FormData()
		formData.append('name', this.profileForm.get('name')?.value)
		formData.append('profile', this.profileForm.get('profile')?.value)

		const file = this.profileForm.get('profile')?.value
		console.log('file:', file)
		console.log('codigo:', this.codigo)
		console.log('usuarioNome:', this.usuarioNome)
		this.getBase64(file).then((res) => {
			const documentoPart: any[] = file.name.split('_', file.length)
			this.registroAtividade = new RegistroAtividade()
			this.isDisabled = true
			this.documento = {
				nomeArquivo: file.name,
				data: `${new Date().getDate().toString()}/${new Date().getMonth() + 1}/${new Date().getFullYear().toString()} ${new Date()
					.getHours()
					.toString()}:${new Date().getMinutes().toString()}:${new Date().getSeconds().toString()}`,
				tipo: 'upload',
				processo: this.processo,
				grupo: '',
				usuario: this.usuarioNome,
				conteudoBase64: res,
			}

			console.log('Enviando documento:', this.documento)
			this.uploadInternoService.enviarDocumento(formData, this.documento).subscribe(
				(res) => {
					console.log('Resposta enviarDocumento:', res)
					this.fileUpload = res
					if (res.name === 'TimeoutError' || res.name === '') {
						console.log('Erro: TimeoutError')
						this.notificationService.showMessage(res.status, `Erro ao tentar fazer o envio do arquivo! Mensagem: ${res.message}`, 'create', this.dynamicUrl)
					}
					if (res.status == 201) {
						console.log('Upload OK - status 201')
            this.messageService.clear()
						this.responseEnvioArquivo = res.body
						this.notificationService.showMessage(res.status, `Arquivo ${this.file.nome} enviado com sucesso.`, 'create', this.dynamicUrl)
						this.resetForm()
						this.ngOnInit()
						this.sucessRequest = true
						console.log('Buscando grupo por empresa com codigo:', this.codigo)
						this.getGrupoByEmpresa(this.responseEnvioArquivo)
					}
				},
				(error) => {
					this.notificationService.showMessage(error, `Erro ao tentar fazer o envio do arquivo! Mensagem: ${error}`, 'create', this.dynamicUrl)
				}
			)
		})
	}

	uploadCheckedCaracteres(file): Promise<File> {
		const parsed: string[] = []
		let blob: any = null
		if (file) {
			return new Promise((resolve, reject) => {
				const fileReader = new FileReader()
				fileReader.onload = (e) => {
					const line = fileReader.result!.toString()
					const removeAccent = line!
						.normalize('NFD')
						.replace(/[\u0300-\u036f]/gi, '')
						.toString()
					parsed.push(removeAccent)
					blob = new File(parsed, file!.nome)
					resolve(blob)
				}
				fileReader.readAsText(file, 'ISO-8859-1')
				fileReader.onerror = (error) => reject(error)
			})
		} else {
			return file
		}
	}

	getBase64(file): Promise<string> {
		const doc: any[] = file.name.split('_', file.length)
		if (doc.length >= 3) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () => {
					const line = reader.result?.toString()
					let encoded = line!.toString().replace(/^data:(.*;base64,)?/, '')
					if (encoded!.length % 4 > 0) encoded += '='.repeat(4 - (encoded!.length % 4))
					resolve(encoded)
				}
				reader.readAsDataURL(file)
				reader.onerror = (error) => reject(error)
			})
		} else {
			return file
		}
	}

	getCompactados(filename, data) {
		this.zipFile.file(filename, data, { binary: true })
	}

	formatedDate(data: Date) {
		const dataHora = data.toString().split(' ')
		const dataFormated = dataHora[0].split('/')
		const newFormated = `${this.adicionaZero(dataFormated[0])}-${this.adicionaZero(dataFormated[1])}-${dataFormated[2]}`
		return newFormated
	}

	formatedHora(data: Date) {
		const dataHora = data.toString().split(' ')
		const dataFormated = dataHora[1]
		return dataFormated
	}

	download(arquivo: RegistroAtividade) {
		this.getLinkFile(arquivo)
		const registroAtividade = {
			tipo: TipoAtividade.download,
			nomeProcesso: this.processo,
			idGrupo: '',
			nomeGrupo: '',
			usuario: this.usuarioNome,
			nomeArquivo: arquivo.nomeArquivo,
			dataHora: new Date(),
			nomeArquivoEnviado: arquivo.nomeArquivoEnviado,
		}
		this.uploadInternoService.postRegistroAtividades(registroAtividade).subscribe({
			next: (result) => {
				console.log(result)
			},
			error: (error) => {
				console.error(error)
			},
		})
	}

	getLinkFile(arquivo) {
		const nomeFile = arquivo.nomeArquivo.substring(arquivo.nomeArquivo.indexOf('pta-out/') + 8).split('?')

		this.uploadInternoService.getFiles(nomeFile[0]).subscribe((res) => (location = res.blobStorage.link))
	}

	getGrupoByEmpresa(arquivo: any) {
		console.log('=== getGrupoByEmpresa ===')
		console.log('codigo para buscar:', this.codigo)
		this.grupoService.getGrupos().subscribe((res) => {
			console.log('Resposta getGrupos:', res)
			if (res.status >= 400) {
				console.log('Erro ao buscar grupos:', res.status)
				this.notificationService.showMessage(res.status, res.statusText, 'read', this.dynamicUrl)
			} else {
				var grupo = res.grupos.filter((grupo) => {
					return grupo.empresas.some((empresa) => empresa.codigo === this.codigo)
				})
				console.log('Grupo encontrado:', grupo)
				if (grupo.length > 0) {
					this.getUsuariosByGrupo(grupo[0], arquivo)
				} else {
					console.log('Nenhum grupo encontrado para o código:', this.codigo)
				}
			}
		})
	}

	getUsuariosByGrupo(grupo: Grupo, arquivo) {
		console.log('=== getUsuariosByGrupo ===')
		console.log('grupo:', grupo)
		this.usuarios = []
		this.uploadInternoService.getUsuariosByGrupo(grupo.id).subscribe((res) => {
			console.log('Resposta getUsuariosByGrupo:', res)
			if (res.status >= 400) {
				console.log('Erro ao buscar usuários:', res.status)
				this.notificationService.showMessage(res.status, res.statusText, 'read', this.dynamicUrl)
			} else {
				this.usuarios = res.Documents
				console.log('Usuários encontrados:', this.usuarios)
				this.sendEmail(arquivo)
			}
		})
	}

	sendEmail(arquivo) {
		console.log('=== sendEmail ===')
		this.destinatarios = this.usuarios.map((usuario) => usuario.email)
		console.log('destinatarios:', this.destinatarios)
		const ano = this.anoMes.substring(0, 4)
		const mes = this.anoMes.substring(4, 6)

		const anomes = `${mes}/${ano}`
		console.log('anomes:', anomes)
		if (this.destinatarios.length != 0) {
			var emailCalculoRetroativo = new Email()
			;(emailCalculoRetroativo['destinatarios'] = this.destinatarios),
				(emailCalculoRetroativo['assunto'] = `Informativo PTA - ${ambiente}`),
				(emailCalculoRetroativo['corpo'] = messageSendEmailCalculoRetroativo
					.replace('{0}', arquivo.nomeArquivoEnviado)
					.replace('{1}', anomes)
					.replace('{2}', `${urlPTA}/upload/interno`))

			this.emailService.sendEmail(emailCalculoRetroativo).subscribe(
				(_res) => {
					console.log('E-mail enviado!')
				},
				(error) => {
					console.log(error)
				}
			)
		} else {
			this.notificationService.showMessage(404, 'Não existe usuários cadastrados para esse grupo', 'read', this.dynamicUrl)
		}
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe())
	}
}
